const annualReportSteps = {
    purchaser: "purchaser",
    belowEu: "belowEu",
    aboveEu: "aboveEu",
    conflict: "conflict",
    community: "community",
    social: "social",
    innovative: "innovative",
    exception: "exception",
    notIncluded: "notIncluded",
}

export const annualReportStepsOrder = [annualReportSteps.purchaser, annualReportSteps.belowEu, annualReportSteps.aboveEu, annualReportSteps.conflict,
    annualReportSteps.community, annualReportSteps.social, annualReportSteps.innovative, annualReportSteps.exception, annualReportSteps.notIncluded];
export const annualReportTablesWithInitialize = [annualReportSteps.belowEu, annualReportSteps.aboveEu, annualReportSteps.conflict, annualReportSteps.community,
    annualReportSteps.social, annualReportSteps.innovative, annualReportSteps.exception, annualReportSteps.notIncluded]
export default annualReportSteps